import { render, staticRenderFns } from "./BlackjackTables.vue?vue&type=template&id=67bafa73&scoped=true"
import script from "./BlackjackTables.vue?vue&type=script&lang=js"
export * from "./BlackjackTables.vue?vue&type=script&lang=js"
import style0 from "./BlackjackTables.vue?vue&type=style&index=0&id=67bafa73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bafa73",
  null
  
)

export default component.exports